import React from "react";
import {
  PrimaryButton,
  SecondaryButton,
} from "../../UI/DesignStandards/Buttons";

const ActionButtons = ({
  canSubmit,
  submitLabel,
  onAddToCart,
  onBackToTournament,
  error = null,
  hint = null,
}) => {
  return (
    <div>
      {error ? (
        <p data-signup-error="" className="mb-4 text-sm text-red-600">
          {error}
        </p>
      ) : null}
      {!canSubmit && hint ? (
        <p className="mb-3 text-sm text-brand-muted">{hint}</p>
      ) : null}
      <div className="flex flex-col sm:flex-row gap-4">
      <SecondaryButton onClick={onBackToTournament} className="flex-1">
        Back to tournament
      </SecondaryButton>
      <PrimaryButton
        onClick={onAddToCart}
        disabled={!canSubmit}
        className="flex-1"
      >
        {submitLabel}
      </PrimaryButton>
      </div>
    </div>
  );
};

export default ActionButtons;
